// Anchor navigation with more entries than fit into the bar (#navMain[data-nav-overflow], partials/header/navi.onepage.html.twig):
// from lg on the entries that do not fit move, from the end, into the dropdown "Mehr" at the end of the bar; the bar never
// runs past its edge, however many entries come. Below lg the entries stay in the menu panel. The entries are moved as they
// are, so the scroll spy (initAnchorNav.js) keeps marking them; "Mehr" is marked while one of its entries is the active one
// (event navactivechange), and the glide indicator (initNaviGlide.js) then sits below it.
export default function initNavOverflow() {
    const list = document.querySelector('#navMain[data-nav-overflow]');
    const more = list?.querySelector(':scope > .nav-item--more');
    const menu = more?.querySelector('.dropdown-menu');
    if (!list || !more || !menu) {
        return;
    }

    const entries = [...list.querySelectorAll(':scope > .nav-item--anchor')];
    const desktop = window.matchMedia('(min-width: 992px)');
    const overflows = () => list.scrollWidth > list.clientWidth + 1;

    const markMore = () => more.classList.toggle('active', menu.querySelector('.nav-link.active') !== null);

    const fit = () => {
        // all entries back into the bar, in their order, before "Mehr"
        entries.forEach((entry) => list.insertBefore(entry, more));
        more.hidden = true;
        if (desktop.matches && overflows()) {
            more.hidden = false;
            for (let i = entries.length - 1; i > 0 && overflows(); i--) {
                menu.prepend(entries[i]);
            }
        }
        markMore();
    };

    let frame = 0;
    const refit = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(fit);
    };

    fit();
    desktop.addEventListener('change', refit);
    window.addEventListener('resize', refit);
    // the bar shrinks on scrolling and the fonts may arrive late: measure again when the room or the text changes
    if (typeof ResizeObserver === 'function') {
        new ResizeObserver(refit).observe(list.parentElement);
    }
    document.fonts?.ready.then(refit);
    list.addEventListener('navactivechange', markMore);
}
